/**
 * An immutable RoboQL query used to hold convenient properties
 * about the query.
 */
export class RoboqlQuery {
  /** The chip shows this one line; the rest live behind the hover preview. */
  readonly firstLine: string;
  /** Lines with something on them. A trailing newline does not add one. */
  readonly lineCount: number;

  private constructor(private readonly text: string) {
    // Two splits rather than one: `firstLine` comes from the raw text, so a
    // single-line query keeps its trailing spaces, while `lineCount` comes
    // from the trimmed text, so a trailing newline is not a line.
    this.firstLine = text.split("\n")[0] ?? "";
    this.lineCount = text.trimEnd().split("\n").length;
  }

  static from(text: string): RoboqlQuery {
    return new RoboqlQuery(text);
  }

  get isMultiline(): boolean {
    return this.lineCount > 1;
  }

  /**
   * The text exactly as given, never normalized
   */
  toString(): string {
    return this.text;
  }
}
